// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate";

// Types
import type { I_UseValidate_Return } from "../index";

/** Функция-валидатор для поля "ИМЕЙ" */
export default function serialValidation(value: string): I_UseValidate_Return {
    if (!value) {
        return {
            status: false,
            message: "",
        };
    }

    if (!/^[A-Za-z0-9]{5,25}$/.test(value)) {
        return {
            status: false,
            message: useTranslate("tiw__enterImei__serial__error__length"),
        };
    }

    return {
        status: true,
        message: "",
    };
}
